export default __webpack_public_path__ + "static/media/barbarianaction.6c79902d.png";